import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburger = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 3.75,
			y1: 5.25,
			x2: 14.25,
			y2: 5.25,
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.75,
			y1: 9.25,
			x2: 14.25,
			y2: 9.25,
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3.75,
			y1: 13.25,
			x2: 14.25,
			y2: 13.25,
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgHamburger);
export default ForwardRef;
